import {
  GetItPerformanceResponse,
  GetProcessesItPerformanceResponseProcess,
} from "../../client/AuthedClient";
import { Table } from "../Table";
import { itSummaryCard } from "./";
import { useState } from "react";
import { LineChart } from "../Charts";
import { TrendModal } from "./TrendModal";
import { DateTime } from "luxon";
import { useAuthedClient } from "../../context/AuthedClientContext";
import { useFilters } from "../../context/FiltersContext";
import React from "react";
import DountChart from "./DountChart";
import { DetailsIcon } from "../Icons";
import { roundNumber } from "../../utils/Mathimatics";
export const MemoryPerformanceTab = (props: {
  data: GetItPerformanceResponse;
  lineData: any;
  // intialPage: number | undefined | null;
}) => {
  const { data, lineData } = props;
  const filters = useFilters();
  const { startDate, endDate, user } = filters;
  const authedClient = useAuthedClient();
  const [lineDetails, setLineDetails] = useState([]);
  const [showTrendModal, setShowTrendModal] = useState(false);
  const [currentAppName, setCurrentAppName] = useState("");
  const [date, setDate] = useState(startDate);
  const [toDate, setToDate] = useState(endDate);
  const handleCloseTrendModal = () => {
    setDate(startDate);
    setToDate(endDate);
    setShowTrendModal(false);
  };
  const handleShowTrendModal = (appName: string) => {
    setCurrentAppName(appName);
    setShowTrendModal(true);
  };
  async function getTrendLineDetails(
    start: DateTime | Date | any,
    end: DateTime | Date | any,
    id: string
  ) {
    await authedClient
      .getDetailedLineChartData(start, end, id)
      .then((res: any) => {
        let objdata: any = [];
        let avgData: any = [];
        if (res) {
          res.data.data.map((el: any) => {
            objdata = [
              ...objdata,
              { xValue: el.xAxisValue, yValue: el.averageMemoryPercentage },
            ];
            avgData.push(res.data.averageMemoryPercentageForLastPeriod);
            return 0;
          });
          let obj: any = {
            labelFormat: res.data.timeLabel,
            data: objdata,
            avg: avgData,
          };
          setLineDetails(obj);
        }
      });
  }
  const columns = [
    { name: "Application Name", attr: "processName" },
    {
      name: "Avg Usage %",
      attr: "averageMemoryPercentage",
    },
    {
      name: "Avg Usage(MB)",
      attr: "averageMemoryInMb",
    },
    { name: "Number of devices", attr: "computersCount" },
    { name: "Trend", attr: "", style: { width: "70px" } },
  ];
  user && delete columns[3];

  const rowStrings = {
    key: "processName",
    items: data.map((application) => [application.processName]),
  };
  const memoryData: { TimeLabel: string; data: Array<any> } = {
    TimeLabel: lineData.data.timeLabel,
    data: [],
  };
  lineData.data.data.length !== 0 &&
    lineData.data.data.map((el: any) => {
      let sampleMemoryObj = {
        xValue: el.xAxisValue,
        yValue: el.averageMemoryPercentage,
      };
      memoryData.data.push(sampleMemoryObj);
      return 0;
    });
  const rows = (array: Array<GetProcessesItPerformanceResponseProcess>) => {
    return array.map((application, index) => (
      <tr key={index}>
        <td>{application.processName}</td>
        <td>{application.averageMemoryPercentage}%</td>
        <td>{application.averageMemoryInMb}</td>
        {!user && <td>{application.computersCount}</td>}
        <td>
          <DetailsIcon
            handleOpenModal={() => {
              getTrendLineDetails(
                startDate,
                endDate,
                application.processName
              ).then(() => {
                handleShowTrendModal(application.processName);
              });
            }}
          />
        </td>
      </tr>
    ));
  };

  const rowsData: any = [];
  const excelData: any = [];

  data.forEach((el) => {
    const obj = {
      processName: el.processName,
      averageMemoryPercentage: roundNumber(el.averageMemoryPercentage, 2),
      averageMemoryInMb: roundNumber(el.averageMemoryInMb, 2),
      computersCount: el.computersCount,
    };
    rowsData.push(obj);
    excelData.push(obj);
  });

  return (
    <React.Fragment>
      <div className="row">
        <div className="col-lg-6 col-sm-12">
          <div className="it-performance-chart-box it-performance-container">
            {itSummaryCard(data, "averageMemoryInMb", "Avg Usage (MB)")}
          </div>
        </div>
        <div className="col-lg-6 col-sm-12">
          <div className="it-performance-chart-box it-performance-container">
            <DountChart
              data={data}
              title={"Usage Consumption %"}
              attr={"averageMemoryPercentage"}
            />
          </div>
        </div>
        <div className="col-xl-12">
          <div className="it-performance-chart-box it-performance-container">
            <LineChart
              max={undefined}
              data={memoryData}
              title={"Avg Memory Usage %"}
              xAxisTitle={`Time in ${lineData.data.timeLabel}s`}
              yAxisTitle=""
              yAxisTickAmount={5}
            />
          </div>
        </div>
        <div className="col-xl-12">
          <div className="it-performance-container">
            <Table
              pageTitle={"Memory Performance"}
              rows={rows}
              // intialPage={intialPage}
              rowsData={rowsData}
              excelData={excelData}
              columns={columns}
              rowsStrings={rowStrings}
            />
          </div>
        </div>
      </div>
      {showTrendModal ? (
        <TrendModal
          getTrendLineDetails={getTrendLineDetails}
          data={lineDetails}
          title="Avg Usage %"
          showTrendModal={showTrendModal}
          handleCloseTrendModal={handleCloseTrendModal}
          currentAppName={currentAppName}
          date={date}
          setDate={setDate}
          toDate={toDate}
          setToDate={setToDate}
        />
      ) : (
        <></>
      )}
    </React.Fragment>
  );
};
